import { render, staticRenderFns } from "./SpeakerEdit.vue?vue&type=template&id=5c53b3f2&scoped=true&"
import script from "./SpeakerEdit.vue?vue&type=script&lang=js&"
export * from "./SpeakerEdit.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerEdit.vue?vue&type=style&index=0&id=5c53b3f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53b3f2",
  null
  
)

export default component.exports